import { render, staticRenderFns } from "./slides.vue?vue&type=template&id=59d67656&scoped=true&"
import script from "./slides.vue?vue&type=script&lang=js&"
export * from "./slides.vue?vue&type=script&lang=js&"
import style0 from "./slides.vue?vue&type=style&index=0&id=59d67656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d67656",
  null
  
)

component.options.__file = "slides.vue"
export default component.exports